'use strict';

import React from 'react'

import { Component } from 'react'

const { app } = window;

export default class Collapse extends Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			open: false
		};

		this.handleDocumentResized = this.handleDocumentResized.bind(this);
		this.handleClick           = this.handleClick.bind(this);
	}

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props;

		component.setState(
		{
			open: props.defaultsOpen === true
		});

		app.push(
		{
			type: 'listener',
			event: 'documentResized',
			cb: component.handleDocumentResized
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			type: 'listener',
			event: 'documentResized',
			cb: component.handleDocumentResized
		});
	}

	handleDocumentResized ()
	{
		const component = this, props = this.props;

		component.setState(
		{
			open: false
		});
	}

	handleClick ()
	{
		const component = this, props = this.props;

		component.setState({ open: !component.state.open });
	}

	render ()
	{
		const component = this, props = this.props;

		var class_name = 'c-collapse u-no-select' + ' ' + props.className;

		if (component.state.open === true)
		{
			class_name += ' c-collapse--open';
		}

		var output =
		(
			<div className={ class_name } style={ props.style }>

				<div className="c-title c-title--collapsible"
					onClick={ component.handleClick }>
					<h2 className="c-title__txt">
						{ props.title }
					</h2>
				</div>

				<div className="c-collapse__wrapper">

					<div className="c-collapse__body">
						{ props.children }
					</div>

				</div>

			</div>
		);

		return output;
	}
}
